import { redirect, type RouteObject } from 'react-router'
import invariant from 'tiny-invariant'
import { type RouteKey, Routes } from '../routes.ts'
import { isLabsEnabled } from './runtime-env.ts'

/**
 * Route loader for a Labs feature's page. A loader rather than a guard component, so with Labs off
 * the page never renders and none of its data hooks issue a request. Deep links fall back to the
 * default page.
 */
export const requireLabs = () => (isLabsEnabled() ? null : redirect(Routes.RepositoriesPage.path))

/** Attaches `requireLabs` to every route `Routes` marks `isLabs`, so no Labs page can skip the gate. */
export const withLabsGate = (key: RouteKey, route: RouteObject): RouteObject => {
  if (!('isLabs' in Routes[key])) {
    return route
  }
  invariant(route.loader === undefined, `Labs route ${key} has its own loader, which the Labs gate would replace`)
  return { ...route, loader: requireLabs }
}
